
/* KWALIFIKATOR (wzor: LeadTok). Napisy w JS sekwencjami \uXXXX, jak w reszcie sekcji. */
(function(){
var F=document.getElementById('form'),K=document.getElementById('kw');if(!F||!K)return;
var LOG=document.getElementById('kw-log'),SR=document.getElementById('kw-sr'),form=document.getElementById('kw-lead'),
    sink=document.getElementById('kw-sink'),sub=document.getElementById('kw-submit');
if(!LOG||!form||!sub)return;
var FLOW=window.KW_FLOW;if(!FLOW)return;
var CK='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>';
var SEND_SVG='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 2L11 13"/><path d="M22 2l-7 20-4-9-9-4z"/></svg>';
var HAND='<svg viewBox="0 0 24 24" fill="#fff" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 14a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15V4a2 2 0 1 1 4 0v6"/><path d="M11 10V8a2 2 0 1 1 4 0v3"/><path d="M15 11V9.5a2 2 0 1 1 4 0V12"/><path d="M19 12a1.5 1.5 0 1 1 3 0v2"/></svg>';
/* TEMPO (ms). Cala szybkosc kwalifikatora siedzi w tej tabeli.
   Bazowo (jak LeadTok): znak 20, po kropce 200-320, po przecinku 110-180, kropki 700,
   odpowiedz 200, krok 400, podsumowanie 300, telefon 250, wybor wielokrotny 2800.
   21.09 na prosbe wlasciciela okolo dwa razy szybciej: 11 (dlugie 8), 90-150, 55-95,
   350, 120, 200, 180, 150, 1700. 26.09 posrodku, bo po skroceniu bylo za szybko. */
var TEMPO={znak:15,znakDlugi:11,kropka:[140,230],przecinek:[80,135],kropki:550,
  popraw:120,odp:160,krok:300,podsum:240,tel:200,kafel:70,kafelStart:160};
var NUDGE_MS=2300,NUDGE_EVERY=4900,MULTI_MS=2300;
/* Awaryjna wysylka: gdy ktos podal numer, ale nie dopisal e-maila, po FALLBACK_MS
   (albo gdy zamyka strone) zgloszenie idzie z samym numerem i adresem
   zastepczym, zeby lead nie przepadl. Sklep wymaga jakiegos e-maila. */
var FALLBACK_MS=60000,EMAIL_FALLBACK='brak.maila@syldatk.pl';
var fbT=null,sentFull=false,sentFallback=false;
var NUDGE=(window.KW_NUDGE>=1&&window.KW_NUDGE<=4)?window.KW_NUDGE:1;
var ARROW='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 4v16M5 13l7 7 7-7"/></svg>';
var RM=false;try{RM=window.matchMedia('(prefers-reduced-motion: reduce)').matches;}catch(e){}
var TOUCH=false;try{TOUCH=window.matchMedia('(hover: none)').matches;}catch(e){}

F.classList.add('kwon');


var ans=[],TEL='',started=false;
function el(t,c,h){var e=document.createElement(t);if(c)e.className=c;if(h!=null)e.innerHTML=h;return e;}
/* Dosuwamy nowy element tylko wtedy, gdy chowa sie tuz pod dolna krawedzia
   (np. pod paskiem). Jesli klient odjechal w gore albo w dol, nie szarpiemy. */
function see(e){try{var r=e.getBoundingClientRect(),vh=window.innerHeight;
  if(r.bottom>vh-96&&r.top<vh+320&&r.top>0)e.scrollIntoView({behavior:RM?'auto':'smooth',block:'nearest'});}catch(x){}}
function wait(ms){return new Promise(function(r){setTimeout(r,RM?0:ms);});}
/* Pisanie litera po literze jak w LeadTok, tempo z tabeli TEMPO; pauzy po kropce
   i przecinku sa losowe, zeby nie bylo mechanicznie. */
function rnd(a,b){return a+Math.random()*(b-a);}
/* Podczas pisania dluzszego dymka ekran jedzie razem z tekstem: gdy dymek
   urosnie o linijke i schowa sie pod dolna krawedzia, dosuwamy o tyle, ile trzeba. */
function follow(e){try{var r=e.getBoundingClientRect(),vh=window.innerHeight,pad=window.innerWidth<768?96:24;
  if(r.top>0&&r.bottom>vh-pad)window.scrollBy(0,r.bottom-(vh-pad));}catch(x){}}
function type(b,text){return new Promise(function(res){var i=0,sp=el('span'),lastH=b.offsetHeight;b.appendChild(sp);
  /* dluzsze zdania pisza sie szybciej, zeby czekanie nie roslo z dlugoscia tekstu */
  var SPD=text.length>110?TEMPO.znakDlugi:TEMPO.znak;
  (function step(){i++;sp.textContent=text.slice(0,i);
    var h=b.offsetHeight;if(h!==lastH){lastH=h;follow(b);}
    if(i<text.length){var ch=text.charAt(i-1);
      setTimeout(step,(ch==='.'||ch==='!'||ch==='?')?rnd(TEMPO.kropka[0],TEMPO.kropka[1]):((ch===','||ch===':')?rnd(TEMPO.przecinek[0],TEMPO.przecinek[1]):SPD));}
    else{see(b);res();}})();});}
/* Dymek w dwoch krokach: mkBub od razu wstawia kropki (da sie to zrobic
   synchronicznie w gescie dotkniecia), fillBub po TEMPO.kropki dopisuje tekst. */
function mkBub(cls){var b=el('div','bub'+(cls?' '+cls:''));b.appendChild(el('span','dots','<i></i><i></i><i></i>'));LOG.appendChild(b);see(b);return b;}
function fillBub(b,text){return wait(TEMPO.kropki).then(function(){b.innerHTML='';if(RM){b.textContent=text;}else{return type(b,text);}})
    .then(function(){if(SR&&LOG.contains(b))SR.textContent=text;});}
function bubble(text,cls){return fillBub(mkBub(cls),text);}
function sumText(){var s=FLOW.sum,L='abcdef';ans.forEach(function(a,i){s=s.replace('{'+L.charAt(i)+'}',a.s);});return s;}
/* Czytniki ekranu: pelny tekst dymka trafia do ukrytego regionu aria-live dopiero
   po dopisaniu, zeby nie czytaly go litera po literze. */

function tileHtml(o,idx){return '<span class="ic">'+o.i+'</span><span>'+o.t+'</span><span class="ck">'+CK+'</span>'
  +'<span class="hand" aria-hidden="true">'+HAND+'</span><span class="rip" aria-hidden="true"></span>';}
function joinPl(list){if(list.length<2)return list.join('');
  var sep=list.some(function(x){return / i /.test(x);})?' oraz ':' i ';
  return list.slice(0,-1).join(', ')+sep+list[list.length-1];}

/* Cofanie odpowiedzi. Kazdy kafel w odpowiedzianym pytaniu (klasa .set) jest
   klikalny: klikniecie usuwa wszystko, co pojawilo sie pozniej (reakcja,
   kolejne pytania, podsumowanie, numer, e-mail), skraca liste odpowiedzi i
   otwiera pytanie na nowo; potem klikniecie dziala jak zwykle. Trwajace
   animacje (pisanie dymka, przerwy) sa przerywane licznikiem gen: kazdy
   lancuch obietnic zapamietuje gen z chwili startu i po cofnieciu milknie. */
var gen=0;
function alive(G){return G===gen;}
function stop(){return new Promise(function(){});}
function busy(){return sentFull||K.classList.contains('done');}
function rewindTo(g){gen++;stopNudge();
  if(openMulti){if(openMulti.t)clearTimeout(openMulti.t);if(openMulti.hint)openMulti.hint.remove();openMulti=null;}
  while(g.nextSibling)LOG.removeChild(g.nextSibling);
  ans.length=g.__at;TEL='';if(fbT){clearTimeout(fbT);fbT=null;}
  g.classList.remove('set');
  var st=g.__st;if(st){st.adv=false;st.entry=null;st.t=null;st.hint=null;st.bar=null;}
  MAILP=null;if(SR)SR.textContent='';}

/* Poprawka zamiast cofania. Gdy klient zmienia zdanie w pytaniu, na ktore juz
   odpowiedzial, nie zerujemy kroku: potwierdzamy zmiane jednym zdaniem i
   przechodzimy dalej od nowa. Dzieki temu klikniecie zawsze daje widoczna
   reakcje, niezaleznie od tego, czy licznik zdazyl wystartowac nastepne pytanie. */
var POPRAW=['Jasne, poprawiamy.','Dobrze, notujemy zmian\u0119.','Oczywi\u015bcie, uwzgl\u0119dniamy to.'];
function popraw(){return POPRAW[Math.floor(Math.random()*POPRAW.length)];}
function amend(g,node,st,opis){gen++;stopNudge();
  if(openMulti){if(openMulti.t)clearTimeout(openMulti.t);if(openMulti.hint)openMulti.hint.remove();openMulti=null;}
  while(g.nextSibling)LOG.removeChild(g.nextSibling);
  ans.length=g.__at+1;TEL='';MAILP=null;sentFallback=false;if(fbT){clearTimeout(fbT);fbT=null;}
  g.classList.add('set');
  if(st){st.t=null;st.hint=null;st.bar=null;}
  if(SR)SR.textContent='';
  var G=gen,txt=opis?('Jasne, poprawiamy. Zapisujemy: '+opis+'.'):popraw();
  bubble(txt,'r').then(function(){if(!alive(G))return stop();return wait(TEMPO.krok);})
    .then(function(){if(!alive(G))return;if(node.n)ask(node.n);else finish();});}

function ask(id){var node=FLOW.q[id];if(!node){finish();return;}
  if(node.type==='multi'){askMulti(node);return;}
  var G=gen;
  /* otwarte multi zostaje klikalne az do odpowiedzi na to pytanie (pick) */
  bubble(node.q,'q').then(function(){if(!alive(G))return;
    var g=el('div','opts');g.style.setProperty('--n',node.o.length);g.setAttribute('data-n',node.o.length);g.__at=ans.length;
    node.o.forEach(function(o,idx){
      var b=el('button','opt');b.type='button';b.innerHTML=tileHtml(o,idx);b.setAttribute('aria-pressed','false');
      b.addEventListener('click',function(){
        if(busy())return;
        var pop=false;
        if(g.classList.contains('set')){if(b.classList.contains('on'))return;rewindTo(g);pop=true;}
        g.classList.add('set');
        g.querySelectorAll('.opt').forEach(function(x){x.classList.toggle('on',x===b);x.setAttribute('aria-pressed',x===b?'true':'false');});
        stopNudge();pick(node,o,pop);});
      g.appendChild(b);
      setTimeout(function(){b.classList.add('in');},RM?0:TEMPO.kafel*idx+TEMPO.kafelStart);});
    LOG.appendChild(g);see(g);
    startNudge(g,ans.length===0);});}

/* Pytanie wielokrotnego wyboru BEZ przycisku "Dalej": po pierwszym kliknieciu
   czekamy MULTI_MS (pasek pod kaflami), kazde kolejne klikniecie liczy czas od
   nowa; potem idziemy dalej, ale kafle zostaja aktywne az do odpowiedzi na
   nastepne pytanie (zaznaczenie aktualizuje sie w tle). Odznaczenie
   wszystkiego cofa formularz do tego pytania. "Nie, tylko ..." / "Nie wiem"
   (none) i "Cala stolarka" (all) koncza krok od razu. */
var openMulti=null;
function lockMulti(){if(!openMulti)return;var m=openMulti;openMulti=null;if(m.t){clearTimeout(m.t);m.t=null;}
  m.g.classList.add('set');
  if(m.hint){m.hint.remove();m.hint=null;}}
function askMulti(node){var G=gen;
  bubble(node.q,'q').then(function(){if(!alive(G))return;
    var opts=node.o.slice();if(node.none)opts.push({t:node.none.t,i:node.none.i,none:true});
    var g=el('div','opts multi'+(node.none?' nn':''));g.style.setProperty('--n',node.o.length);g.setAttribute('data-n',node.o.length);g.__at=ans.length;
    var st={g:g,hint:null,entry:null,adv:false,t:null,bar:null};g.__st=st;
    node.all=node.o.filter(function(o){return o.all;})[0]||null;
    function chosen(){return node.o.filter(function(o){return !o.all&&o.__b&&o.__b.classList.contains('on');});}
    function allVals(){return node.o.filter(function(z){return !z.all;}).map(function(z){return z.v;}).filter(Boolean);}
    /* laczniki: " oraz " po fragmencie, ktory sam juz ma "i"/"oraz", zamienia sie na pre2 (", a takze ") */
    function pre(){var i=g.__at-1,pv=(i>=0&&ans[i])?(ans[i].s||''):'';return (node.pre2&&/ (i|oraz) /.test(pv))?node.pre2:node.pre;}
    function refresh(){var c=chosen(),e=st.entry;if(!e)return;
      if(c.length){e.t=c.map(function(o){return o.t;}).join(', ');e.s=pre()+joinPl(c.map(function(o){return o.s;}));e.x=c.map(function(o){return o.v;}).filter(Boolean);}
      else if(node.none){e.t=node.none.t;e.s=node.none.s||'';e.x=[];}
      else{e.t='';e.s='';e.x=[];}}
    /* reakcja: przy jednym zaznaczeniu jego wlasna, przy kilku wspolna dla pytania */
    function react(){var c=chosen();return (c.length===1&&c[0].r)?c[0].r:node.r;}
    function lock(){g.classList.add('set');}
    function go(r){var G2=gen;
      (r?wait(TEMPO.odp).then(function(){if(!alive(G2))return stop();return bubble(r,'r');}):wait(TEMPO.odp))
        .then(function(){if(!alive(G2))return stop();return wait(TEMPO.krok);})
        .then(function(){if(!alive(G2))return;if(node.n)ask(node.n);else finish();});}
    function arm(){if(st.t)clearTimeout(st.t);
      if(st.bar){st.bar.classList.remove('run');void st.bar.offsetWidth;st.bar.classList.add('run');}
      st.t=setTimeout(function(){st.t=null;if(st.hint){st.hint.remove();st.hint=null;}go(react());},RM?600:MULTI_MS);}
    function advance(r,lockNow){lockMulti();st.adv=true;st.entry={q:node.q,t:'',s:'',x:[]};ans.push(st.entry);refresh();stopNudge();
      if(lockNow){lock();go(r);return;}
      openMulti=st;st.hint=el('p','kw-hint kw-more','<span>Mo\u017cna klikn\u0105\u0107 kolejne kafle. Za chwil\u0119 przejdziemy dalej.</span><i class="kw-prog"><b></b></i>');LOG.appendChild(st.hint);
      st.bar=st.hint.querySelector('.kw-prog b');st.bar.style.setProperty('--ms',(RM?600:MULTI_MS)+'ms');see(st.hint);arm();}
    function setAll(on){node.o.forEach(function(z){if(z.__b){z.__b.classList.toggle('on',on);z.__b.setAttribute('aria-pressed',on?'true':'false');}});}
    opts.forEach(function(o,idx){
      var b=el('button','opt'+(o.none?' none':''));b.type='button';b.innerHTML=tileHtml(o,idx);o.__b=b;b.setAttribute('aria-pressed','false');
      b.addEventListener('click',function(){
        if(busy())return;
        if(o.none){var was=b.classList.contains('on');setAll(false);
          if(was&&st.adv){b.classList.remove('on');b.setAttribute('aria-pressed','false');rewindTo(g);return;}
          b.classList.add('on');b.setAttribute('aria-pressed','true');
          if(!st.adv){advance(node.none.r,true);}
          else if(st.t){clearTimeout(st.t);st.t=null;refresh();lockMulti();go(node.none.r);}
          else{refresh();amend(g,node,st,st.entry?st.entry.t:'');}
          return;}
        if(o.all){var wasAll=b.classList.contains('on');
          if(wasAll&&st.adv){setAll(false);b.classList.remove('on');b.setAttribute('aria-pressed','false');rewindTo(g);return;}
          setAll(true);b.classList.add('on');b.setAttribute('aria-pressed','true');
          if(!st.adv){lockMulti();st.adv=true;st.entry={q:node.q,t:node.all.t,s:node.pre+node.all.s,x:allVals()};ans.push(st.entry);stopNudge();lock();go(node.all.r);}
          else{st.entry.t=node.all.t;st.entry.s=node.pre+node.all.s;st.entry.x=allVals();
            if(st.t){clearTimeout(st.t);st.t=null;lockMulti();go(node.all.r);}else amend(g,node,st,st.entry.t);}
          return;}
        b.classList.toggle('on');b.setAttribute('aria-pressed',b.classList.contains('on')?'true':'false');
        if(node.none&&node.none.__b){node.none.__b.classList.remove('on');node.none.__b.setAttribute('aria-pressed','false');}
        if(node.all&&node.all.__b&&!b.classList.contains('on')){node.all.__b.classList.remove('on');node.all.__b.setAttribute('aria-pressed','false');}
        var c=chosen().length;
        if(!st.adv){if(c)advance(node.r,false);}
        else if(!c){rewindTo(g);}
        else{refresh();if(st.t)arm();else amend(g,node,st,st.entry?st.entry.t:'');}});
      if(o.none)node.none.__b=b;
      g.appendChild(b);
      setTimeout(function(){b.classList.add('in');},RM?0:TEMPO.kafel*idx+TEMPO.kafelStart);});
    LOG.appendChild(g);see(g);
    startNudge(g,ans.length===0);});}

/* Podpowiedz "trzeba kliknac". Cztery warianty, wybor przez NUDGE (1-4):
   1 reka pod kaflami + pierwszy kafel "wciska sie" co kilka sekund,
   2 pigulka nad kaflami ze strzalka + kafle pulsuja po kolei,
   3 fala dotyku wedrujaca po kaflach + podpis,
   4 czerwona strzalka "prosze wybrac" + pierwszy kafel lekko sie kiwa. */
var nudgeT=null,nudgeG=null;
function stopNudge(){if(nudgeT){clearInterval(nudgeT);clearTimeout(nudgeT);nudgeT=null;}
  if(nudgeG){if(nudgeG.__tip){nudgeG.__tip.remove();nudgeG.__tip=null;}
    nudgeG.classList.remove('pulse');nudgeG.querySelectorAll('.opt').forEach(function(x){x.classList.remove('tap','wig','ripon');});}
  nudgeG=null;}
function startNudge(g,first){stopNudge();nudgeG=g;
  var tiles=[].slice.call(g.querySelectorAll('.opt'));if(!tiles.length)return;
  var tip=null;
  if(NUDGE===1&&first){tip=el('p','kw-tip',HAND+'<span>Prosz\u0119 klikn\u0105\u0107 jedn\u0105 z opcji</span>');LOG.insertBefore(tip,g.nextSibling);}
  if(NUDGE===2&&first){tip=el('p','kw-tip up','<span>Prosz\u0119 wybra\u0107 jedn\u0105 z opcji</span>'+ARROW);LOG.insertBefore(tip,g);}
  if(NUDGE===3&&first){tip=el('p','kw-tip','<span>Prosz\u0119 klikn\u0105\u0107 w wybran\u0105 opcj\u0119</span>');LOG.insertBefore(tip,g.nextSibling);}
  if(NUDGE===4){tip=el('p','kw-tip arr',ARROW+'<span>Prosz\u0119 wybra\u0107</span>');LOG.insertBefore(tip,g);}
  g.__tip=tip;
  if(RM)return;
  var k=0;
  function go(){if(nudgeG!==g||g.classList.contains('set'))return;
    if(NUDGE===1){var f=tiles[k%tiles.length];k++;f.classList.remove('tap');void f.offsetWidth;f.classList.add('tap');}
    else if(NUDGE===4){var w=tiles[0];w.classList.remove('wig');void w.offsetWidth;w.classList.add('wig');}
    else if(NUDGE===3){var t=tiles[k%tiles.length];k++;t.classList.remove('ripon');void t.offsetWidth;t.classList.add('ripon');}}
  if(NUDGE===2){setTimeout(function(){if(nudgeG===g&&!g.classList.contains('set'))g.classList.add('pulse');},NUDGE_MS);return;}
  nudgeT=setTimeout(function(){go();nudgeT=setInterval(go,NUDGE===3?1300:NUDGE_EVERY);},NUDGE===3?1400:NUDGE_MS);}

function pick(node,o,pop){lockMulti();var G=gen;ans.push({q:node.q,t:o.t,s:o.s,x:o.v?[o.v]:null});
  (pop?wait(TEMPO.popraw).then(function(){if(!alive(G))return stop();return bubble(popraw(),'r');}):wait(0))
    .then(function(){if(!alive(G))return stop();
      return o.r?wait(TEMPO.odp).then(function(){if(!alive(G))return stop();return bubble(o.r,'r');}):wait(TEMPO.odp);})
    .then(function(){if(!alive(G))return stop();return wait(TEMPO.krok);})
    .then(function(){if(!alive(G))return;if(node.n)ask(node.n);else finish();});}

function finish(){lockMulti();var G=gen;
  bubble(sumText(),'s').then(function(){if(!alive(G))return stop();return wait(TEMPO.podsum);}).then(function(){if(!alive(G))return;phone();});}
/* 9 okienek na numer: cyfry same przeskakuja, wklejenie rozklada sie po polach,
   Backspace cofa, Enter wysyla. Przycisk pojawia sie po 9. cyfrze. */
function phone(){
  var pan=el('div','pan');
  pan.innerHTML='<p class="t">'+CK+'<span>Prosz\u0119 poda\u0107 numer telefonu, oddzwonimy z wycen\u0105</span></p><div class="dig"></div><p class="err" role="alert"></p>'
    +'<button type="button" class="btn btn-red kw-send">'+SEND_SVG+'Wy\u015blij</button><p class="kw-hint">9 cyfr, bez numeru kierunkowego. Oddzwaniamy w godzinach pracy.</p>';
  var dig=pan.querySelector('.dig'),err=pan.querySelector('.err'),go=pan.querySelector('.kw-send');
  var cells=[];
  var grp=null;
  for(var i=0;i<9;i++){if(i%3===0){grp=el('span','grp');dig.appendChild(grp);}
    var c=document.createElement('input');c.type='text';c.inputMode='numeric';
    c.setAttribute('pattern','[0-9]*');c.maxLength=1;c.autocomplete='off';c.setAttribute('autocorrect','off');
    c.setAttribute('aria-label','Cyfra '+(i+1)+' numeru telefonu');grp.appendChild(c);cells.push(c);}
  LOG.appendChild(pan);see(pan);
  function val(){return cells.map(function(c){return c.value;}).join('');}
  function clean(){err.classList.remove('on');}
  function check(){cells.forEach(function(c){c.classList.toggle('f',!!c.value);});pan.classList.toggle('ok',val().length===9);}
  function fill(str,from){var d=str.replace(/\D/g,'');if(d.length>9&&d.indexOf('48')===0)d=d.slice(2);
    var j=from;for(var i=0;i<d.length&&j<9;i++,j++){cells[j].value=d.charAt(i);}
    cells[Math.min(j,8)].focus();check();clean();}
  cells.forEach(function(c,i){
    c.addEventListener('input',function(){var v=c.value.replace(/\D/g,'');
      if(v.length>1){c.value='';fill(v,i);return;}
      c.value=v;if(v&&i<8)cells[i+1].focus();check();clean();});
    c.addEventListener('keydown',function(ev){
      if(ev.key==='Backspace'&&!c.value&&i>0){cells[i-1].value='';cells[i-1].focus();ev.preventDefault();check();}
      else if(ev.key==='ArrowLeft'&&i>0){cells[i-1].focus();ev.preventDefault();}
      else if(ev.key==='ArrowRight'&&i<8){cells[i+1].focus();ev.preventDefault();}
      else if(ev.key==='Enter'){ev.preventDefault();send();}});
    c.addEventListener('paste',function(ev){var t='';
      try{t=(ev.clipboardData||window.clipboardData).getData('text');}catch(e){}
      if(t){ev.preventDefault();fill(t,i);}});
    c.addEventListener('focus',function(){try{c.select();}catch(e){}});});
  function send(){var v=val();
    if(v.length<9){err.textContent='Numer ma 9 cyfr.';err.classList.add('on');cells[v.length].focus();return;}
    TEL=v;pan.classList.add('kw-lock');var G=gen;
    cells.forEach(function(c){c.disabled=true;});
    startFallback();
    wait(TEMPO.tel).then(function(){if(!alive(G))return stop();return bubble('Dzi\u0119kujemy. Prosz\u0119 poda\u0107 jeszcze adres e-mail, na kt\u00f3ry wy\u015blemy wycen\u0119.','r');}).then(function(){if(!alive(G))return;mail();});}
  go.addEventListener('click',send);
  setTimeout(function(){try{cells[0].focus({preventScroll:true});}catch(e){}},RM?0:350);
  /* Caly panel jest celem dotkniecia: klikniecie gdziekolwiek w ramce ustawia
     kursor w pierwszej pustej cyfrze, wiec na telefonie klawiatura otwiera sie
     bez celowania w male okienko. */
  pan.addEventListener('click',function(ev){
    var t=ev.target;if(t.tagName==='INPUT'||(t.closest&&t.closest('button')))return;
    var c=cells.filter(function(x){return !x.value;})[0]||cells[8];try{c.focus();}catch(e){}});
}

var MAILRE=/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
/* Wysylka idzie tak samo jak w starym formularzu sklepu: klient klika prawdziwy
   przycisk submit stojacy w formularzu, a pola z odpowiedziami sa uzupelniane w
   momencie wysylki. armed=true oznacza wysylke techniczna (awaryjna albo po
   weryfikacji), gdzie pola sa juz uzupelnione. */
var MAILP=null,armed=false;
form.addEventListener('submit',function(ev){
  if(armed){armed=false;return;}
  if(!MAILP||sentFull){ev.preventDefault();return;}
  var v=(MAILP.inp.value||'').trim(),kom='';
  if(!v)kom='Prosimy poda\u0107 adres e-mail.';else if(!MAILRE.test(v))kom='Adres e-mail wygl\u0105da na niepe\u0142ny.';
  if(kom){ev.preventDefault();MAILP.err.textContent=kom;MAILP.err.classList.add('on');
    MAILP.inp.classList.add('bad');try{MAILP.inp.focus();}catch(e){}return;}
  prepare(v);
});
function mail(){
  var pan=el('div','pan mail');
  pan.innerHTML='<label for="kw-mail">Adres e-mail</label>'
    +'<input type="email" id="kw-mail" inputmode="email" autocomplete="email" autocapitalize="off" spellcheck="false">'
    +'<p class="err" role="alert"></p>'
    +'<button type="submit" class="btn btn-red" id="kw-fin">Prosz\u0119 o bezp\u0142atn\u0105 wycen\u0119</button>'
    +'<p class="rodo">Administrator danych: P.H.U. SYLDATK, ul. Kartuska 61, Borkowo. Dane s\u0142u\u017c\u0105 wy\u0142\u0105cznie do przygotowania wyceny. <a href="/policies/privacy-policy">Polityka prywatno\u015bci</a></p>';
  var inp=pan.querySelector('input'),err=pan.querySelector('.err'),fin=pan.querySelector('#kw-fin');
  LOG.appendChild(pan);see(pan);
  MAILP={inp:inp,err:err,fin:fin};
  setTimeout(function(){try{inp.focus({preventScroll:true});}catch(e){}},RM?0:350);
  pan.addEventListener('click',function(ev){
    var t=ev.target;if(t.tagName==='INPUT'||(t.closest&&t.closest('button'))||t.tagName==='A')return;
    try{inp.focus();}catch(e){}});
  inp.addEventListener('input',function(){err.classList.remove('on');inp.classList.remove('bad');});
}

function fillForm(email,note,zrodlo){
  var tel=TEL.replace(/(\d{3})(\d{3})(\d{3})/,'$1 $2 $3');
  var lines=['Kwalifikator: '+FLOW.lbl];
  ans.forEach(function(a,i){lines.push((i+1)+'. '+a.q+' '+a.t);});
  lines.push('Telefon: '+tel);
  if(note)lines.push(note);
  lines.push('Strona: '+location.pathname);
  var z=FLOW.ten,extra=[];ans.forEach(function(a){if(a.x&&a.x.length&&a.q!==FLOW.q[FLOW.start].q)extra=extra.concat(a.x);});
  if(FLOW.zmode==='list'){z=extra.length?extra.join(', '):FLOW.ten;}
  else{extra.forEach(function(v){if(v!==z)z+=', '+v;});}
  document.getElementById('kw-zakres').value=z;
  document.getElementById('kw-tel').value=tel;
  document.getElementById('kw-email').value=email;
  document.getElementById('kw-body').value=lines.join('\n');
  var zr=document.getElementById('kw-zrodlo');if(zr)zr.value=zrodlo||'Kwalifikator';}
function startFallback(){if(fbT||sentFull||sentFallback)return;
  fbT=setTimeout(function(){fbT=null;fallbackSend(false);},FALLBACK_MS);
  addEventListener('pagehide',function(){fallbackSend(true);});
  /* Przejscie do innej aplikacji: strona zyje, wiec wysylamy normalnie przez ramke
     (beacon zostaje tylko na zamkniecie karty, gdy nic innego juz nie zadziala). */
  document.addEventListener('visibilitychange',function(){if(document.visibilityState==='hidden')fallbackSend(false);});}
function fallbackSend(beacon){if(sentFull||sentFallback||!TEL)return;sentFallback=true;if(fbT){clearTimeout(fbT);fbT=null;}
  fillForm(EMAIL_FALLBACK,'E-mail: nie podano (zg\u0142oszenie wys\u0142ane automatycznie z samym numerem, klient mo\u017ce jeszcze dopisa\u0107 adres)','Kwalifikator (bez e-maila)');
  if(beacon&&navigator.sendBeacon){try{var fd=new FormData(form);navigator.sendBeacon((form.getAttribute('action')||'/contact').split('#')[0],fd);leadOnce('kwalifikator-telefon');return;}catch(e){}}
  if(sink)form.setAttribute('target','kw-sink');armed=true;sub.click();leadOnce('kwalifikator-telefon');}
/* Jeden lead na zgloszenie: numer wyslany awaryjnie i pozniejsze dopisanie
   e-maila to nadal ta sama osoba, wiec pomiar liczy ja raz. */
var leadDone=false;
function leadOnce(kind){if(leadDone)return;leadDone=true;
  try{if(window.syldatkLead)window.syldatkLead(kind);else if(window.fbq)fbq('track','Lead');}catch(e){}}
function prepare(email){
  sentFull=true;if(fbT){clearTimeout(fbT);fbT=null;}
  fillForm(email,sentFallback?'E-mail dopisany przez klienta po zg\u0142oszeniu z samym numerem':'',sentFallback?'Kwalifikator (uzupe\u0142nienie e-maila)':'Kwalifikator');
  if(sink)form.setAttribute('target','kw-sink');
  setTimeout(function(){
    if(MAILP){MAILP.fin.disabled=true;MAILP.inp.disabled=true;}
    K.classList.add('done');F.classList.add('kwdone');
    var s=document.getElementById('kw-sent');
    if(s){try{s.scrollIntoView({behavior:RM?'auto':'smooth',block:'center'});}catch(e){}}
    leadOnce('kwalifikator');
  },0);
}

/* Sklep odeslal weryfikacje zamiast potwierdzenia: pokazujemy przycisk,
   ktory wysyla formularz jeszcze raz juz bez ramki, zeby klient ja przeszedl. */
if(sink){sink.addEventListener('load',function(){var h='';
  try{h=sink.contentWindow.location.href||'';}catch(e){return;}
  if(h.indexOf('challenge')>-1){K.classList.remove('done');F.classList.remove('kwdone');K.classList.add('chal');
    var s=document.getElementById('kw-chal');if(s)see(s);}});}
var chal=document.getElementById('kw-chal-go');
if(chal)chal.addEventListener('click',function(){form.removeAttribute('target');armed=true;sub.click();});

/* Start: od razu, gdy kwalifikator jest w wiekszosci na ekranie (klient sam do
   niego doszedl); jesli tylko wystaje zza dolnej krawedzi (wejscie na strone),
   dopiero po START_MS, zeby dalo sie spokojnie przeczytac poczatek strony. */
var START_MS=5000;
function start(){if(started)return;started=true;setTimeout(function(){ask(FLOW.start);},RM?0:250);}
/* "Doszedl sam": gorna krawedz kwalifikatora jest w gornej polowie ekranu. */
function reached(){try{var r=K.getBoundingClientRect();return r.top<window.innerHeight*.45&&r.bottom>0;}catch(e){return false;}}
try{
  var st0=null;
  function arm(){if(started)return;if(reached()){start();return;}if(!st0)st0=setTimeout(start,START_MS);}
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){arm();if(started)io.disconnect();}});},{threshold:.1});
    io.observe(K);
  }else arm();
  /* Przewiniecie strony to sygnal, ze klient przeczytal i chce isc dalej:
     wtedy kwalifikator rusza od razu, bez czekania na START_MS. */
  var y0=window.pageYOffset||0;
  addEventListener('scroll',function(){if(started)return;
    if(reached()||Math.abs((window.pageYOffset||0)-y0)>100)start();},{passive:true});
  setTimeout(start,15000);
}catch(e){setTimeout(start,800);}
})();
